export default __webpack_public_path__ + "assets/models/449b5515c35d3d671f98fa1e2270ab3d.glb";